module.exports = __webpack_public_path__ + "static/img/wjxbj1.jpg";